<template>
    <div class="gallery-item collection-index-item">
        <div class="img-content" ref="imageBlock">
            <img 
                v-if="data.media&&data.media?.media_type=='image'"
                :src="data.media?.source_url" 
                loading="lazy" 
                :srcset="data.srcset" 
                :sizes="`${data.width}px`" 
                @click="showFSImg"/>
            <video controls v-if="data.media&&data.media.mime_type.startsWith('video')"
                :src="data.media?.source_url"/>
            <div class="coll-item-banner" v-show="data.media?.caption.rendered">
                <p class="title" ref="caption"></p>
            </div>
        </div>
    </div>
</template>
<style lang="scss">

@media only screen and (max-width: 1023px) {
    .collection-index-item {
        flex: 1 0 auto;
        height: 100%;
    }
}
@media only screen and (min-width: 1024px) {
    .collection-index-item {
        height: 100%;
        width: fit-content;
    }
}

.collection-index-item .img-content {
    position: relative;
    cursor: auto;
    height: 100%;
    //width: fit-content;
    img, video{
        height: 100%;
        width: auto;
        object-fit:contain;
    }
}
.coll-item-banner{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    //line-height: 1rem;
    //margin-right: 1rem;
    padding: 0.5rem;
    background: rgba(0,0,0,0.8);
    color: #fff;
    // display: none;
}
p.title {
    margin-block: 0.5rem;
    font-weight: bold;
    display: block;
    width: 100%;
    white-space: nowrap; /* forces text to single line */
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
}
.collection-index-item .img-content:hover .coll-item-banner {
    opacity: 1;
}
@media only screen and (max-width: 1023.9px) {
    .coll-item-banner {
        display: none;
    }
}
@media only screen and (min-width: 1024px) {
    .collection-index-item .img-content {
        .coll-item-banner {
            opacity: 0;
            transition-property: opacity;
            transition-duration: 0.3s;
        }
        img, video{
            height: 100%;
            width: auto;
            object-fit:contain;
        }
    }
    .collection-index-item .img-content:hover {
        .coll-item-banner {
            opacity: 1;
        }
    }

}
</style>

<script setup>
import { reactive,ref } from 'vue'
import sirapi from '@/sirapi'

import { useFullScreen } from '@/stores/fullscreen_state'
import {usePage} from '@/stores/page_state'

const imageBlock=ref(null)
const caption = ref(null)
const fs = useFullScreen()
const page = usePage()
// eslint-disable-next-line no-undef
const props = defineProps(['id', 'index'])
const data = reactive({media: null,width: 2400, height: 3600, srcset: null})

function showFSImg(){
    //fs.caption = data.media.caption.rendered
    fs.caption = caption.value.textContent
    fs.image = {
        source_url: data.media.source_url,
        width: data.width,
        height: data.height,
        srcset: data.srcset,
    }
    fs.index = props.index
    fs.display = true
}
sirapi.getMedia(props.id)
    .then(
        (response) => {
            let containerHeight = imageBlock.value.parentElement.offsetHeight

            let imageHeight
            let imageWidth

            
            if(response.data.media_type=="image"){
                imageHeight = response.data.media_details.sizes.full.height
                imageWidth = Number(response.data.media_details.sizes.full.width)

                // Build srcset

                let mediaSizes = response.data.media_details.sizes
                let sizes = ["medium","medium_large","large","full"]
                data.srcset = ""
                sizes.forEach(size => {
                    if(mediaSizes[size]) {
                        //console.log(`${size} found`)
                        data.srcset += `${mediaSizes[size].source_url} ${mediaSizes[size].width}w,`
                    }
                });
                if(page.mediaCollection[props.index]==undefined) page.mediaCollection[props.index]={}
                page.mediaCollection[props.index].srcset = data.srcset
            } else if(response.data.mime_type.startsWith("video")) {
                imageHeight = response.data.media_details.height
                imageWidth = Number(response.data.media_details.width)
            } else {
                imageHeight = 0
                imageWidth = 0
            }

            data.height = containerHeight
            data.width = imageWidth / imageHeight * containerHeight
            console.log( containerHeight + ' ' + data.height + ' ' + data.width )

            let el=document.createElement('div')
            el.innerHTML=response.data.caption.rendered
            caption.value.innerHTML=el.textContent
            data.media = response.data
        }
    )



</script>